import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";
import {FlightModeSound} from "../misc/FlightModeSound";
import {RestoreUtils} from "../misc/RestoreUtils";

export class FreeSpinsIntro implements SimplePresentation {

    name:string = "FreesSpinIntro";

    public shouldRun():boolean {
        return !FlightMode.model.isRestore && FlightMode.model.freespinsShouldStart();
    }

    public start(controller:SimplePresentationRunnerController):void {
        const scatterCount = FlightMode.model.scatterCount();
        const autoClickIntro = FlightMode.autoPlayPlugin.isAutoplayRound && FlightMode.model.wasFeatureBuy
        FlightMode.autoPlayPlugin.turnOffAutoplayOnBonus();

        const tl = gsap.timeline();
        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)});
        });

        if (FlightMode.model.isRestore)
            tl.add(() => {}, '>0.5');

        tl.add(() => {
            FlightMode.soundPlayer.fadeOutMusic();
            FlightMode.soundPlayer.playSound("fsSfsActivation");
            FlightMode.keypadPlugin.hide(0.1);
        });
        tl.add(FlightMode.model.scatterPositions().map((pos) => {
            const symbol = FlightMode.reelView.getSymbolAt(pos.reel, pos.row);
            return gsap.timeline()
                .add(FlightMode.reelView.moveUpSymbolAt(pos.reel, pos.row))
                .add(symbol.scatterWinStart())
        }));

        tl.add(FlightMode.transitionScreen.freespinsIntro.show(scatterCount), '>1');
        tl.add(() => {
            FlightMode.soundPlayer.playSound("fsIntroOneShot")
            FlightMode.soundPlayer.playLoopingSound(`fsIntroLoop${  scatterCount == 3 ? 6
                                                                  : scatterCount == 4 ? 9
                                                                   : 12}`);
        }, '<')

        const onButtonClick = () => {
            FlightMode.model.scatterPositions().map((pos) => {
                const symbol = FlightMode.reelView.getSymbolAt(pos.reel, pos.row);
                return gsap.timeline()
                    .add(FlightMode.reelView.moveDownSymbolAt(pos.reel, pos.row))
                    .add(symbol.scatterWinStop())
            });
            FlightMode.keypadPlugin.setZeroBetSpinCounter(FlightMode.model.freespinsLeft);
            FlightMode.keypadPlugin.show(0.1);
            FlightMode.soundPlayer.switchMusic(FlightModeSound.getFreespinsMusic(scatterCount));
            FlightMode.soundPlayer.fadeInMusic()
            FlightMode.soundPlayer.stopSound("fsIntroLoop6")
            FlightMode.soundPlayer.stopSound("fsIntroLoop9")
            FlightMode.soundPlayer.stopSound("fsIntroLoop12")
            FlightMode.backgroundElements.setToFreespins();
            FlightMode.transitionScreen.freespinsIntro.hide();
            controller.setSkipCallback();
            controller.finish();
        };
        if (autoClickIntro)
            tl.add(onButtonClick, '>1.2');
        else
            tl.add(FlightMode.transitionScreen.enableButton(onButtonClick));
    }
}

// needed to make freespins intro finish without player interaction
// during feature buy auto spins
export class FreeSpinsRestoreIntro extends FreeSpinsIntro {
    shouldRun(): boolean {
        return (FlightMode.model.isRestore || RestoreUtils.isActionSpins) &&
               FlightMode.model.freespinsShouldStart();
    }
}